<template>
	<agreement-editor />
</template>
<script>
import AgreementEditor from '@/components/contract/agreement/editor/AgreementEditor.vue';

export default {
	name: 'ContractAgreementEditorView',
	components: { AgreementEditor },
};
</script>
